// extracted by mini-css-extract-plugin
export default {"paragraph":"HowToParticipate_paragraph__ktEKP"};